module.exports = "<md-icon\r\n  class=\"icon\"\r\n  [ngClass]=\"size\"\r\n  mdTooltip=\"{{tooltip}}\"\r\n  mdTooltipPosition=\"above\"\r\n  mdTooltipClass=\"original\"\r\n>\r\n  {{fuente}}\r\n</md-icon>\r\n"


//////////////////
// WEBPACK FOOTER
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/negocios/negocios-fuente-icon/negocios-fuente-icon.component.html
// module id = ../../../../../src/app/components/negocios/negocios-fuente-icon/negocios-fuente-icon.component.html
// module chunks = 0